/**
 * 联系表单模块
 * 实现表单验证（提交时 + 实时 blur 验证）和 AJAX 提交
 */
import { showToast } from './toast.js';

export function initContactForm() {
  const messageForm = document.querySelector('.message-form');
  if (!messageForm) return;

  // ========== 实时验证规则 ==========
  const validators = {
    name: (value) => value.trim().length >= 2 ? '' : '姓名至少需要2个字符',
    email: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : '请输入有效的邮箱地址',
    phone: (value) => !value || /^[\d\-+() ]{7,}$/.test(value) ? '' : '请输入有效的电话号码',
    subject: (value) => value.trim().length >= 2 ? '' : '主题至少需要2个字符',
    message: (value) => value.trim().length >= 10 ? '' : '留言内容至少需要10个字符',
  };

  // 为每个表单字段添加 blur / input 事件验证
  Object.keys(validators).forEach(fieldName => {
    const input = messageForm.querySelector(`[name="${fieldName}"]`)
      || document.getElementById(fieldName);
    if (!input) return;

    // 失焦时验证
    input.addEventListener('blur', () => {
      const error = validators[fieldName](input.value);
      showFieldError(input, error);
    });

    // 输入时清除错误状态
    input.addEventListener('input', () => {
      if (input.classList.contains('field-error')) {
        input.classList.remove('field-error');
        const hint = input.parentElement.querySelector('.field-error-text');
        if (hint) hint.remove();
      }
    });
  });

  // ========== 表单提交 ==========
  messageForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const nameInput = document.getElementById('name');
    const emailInput = document.getElementById('email');
    const phoneInput = document.getElementById('phone');
    const messageInput = document.getElementById('message');

    // 重置错误提示
    resetErrors();

    // 表单验证
    if (!validateForm(nameInput, emailInput, phoneInput, messageInput)) {
      return;
    }

    const formData = {
      name: nameInput.value.trim(),
      email: emailInput.value.trim(),
      phone: phoneInput.value.trim(),
      content: messageInput.value.trim(),
    };

    submitForm(formData, messageForm);
  });

  // ========== 辅助函数 ==========

  /**
   * 显示/清除字段错误提示
   */
  function showFieldError(input, errorMsg) {
    input.classList.remove('field-error');
    const existingHint = input.parentElement.querySelector('.field-error-text');
    if (existingHint) existingHint.remove();

    if (errorMsg) {
      input.classList.add('field-error');
      const hint = document.createElement('span');
      hint.className = 'field-error-text';
      hint.textContent = errorMsg;
      input.parentElement.appendChild(hint);
    }
  }

  /**
   * 表单验证
   */
  function validateForm(nameInput, emailInput, phoneInput, messageInput) {
    let isValid = true;

    if (!nameInput.value.trim()) {
      showError(nameInput, '请输入您的姓名');
      isValid = false;
    }

    if (!messageInput.value.trim()) {
      showError(messageInput, '请输入留言内容');
      isValid = false;
    }

    if (!emailInput.value.trim() && !phoneInput.value.trim()) {
      showError(emailInput, '邮箱和电话至少填写一项');
      showError(phoneInput, '邮箱和电话至少填写一项');
      isValid = false;
    } else {
      if (emailInput.value.trim()) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(emailInput.value.trim())) {
          showError(emailInput, '请输入有效的邮箱地址');
          isValid = false;
        }
      }

      if (phoneInput.value.trim()) {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(phoneInput.value.trim())) {
          showError(phoneInput, '请输入有效的手机号码');
          isValid = false;
        }
      }
    }

    return isValid;
  }

  /**
   * 显示错误提示（DOM API，无内联样式）
   */
  function showError(input, message) {
    const formGroup = input.closest('.form-group');
    if (!formGroup) return;

    const existingError = formGroup.querySelector('.error-message');
    if (!existingError) {
      const errorElement = document.createElement('div');
      errorElement.className = 'error-message';
      errorElement.textContent = message;
      formGroup.appendChild(errorElement);
    }

    input.classList.add('field-error');
  }

  /**
   * 重置所有错误提示
   */
  function resetErrors() {
    messageForm.querySelectorAll('.error-message').forEach(el => el.remove());
    messageForm.querySelectorAll('.field-error-text').forEach(el => el.remove());
    messageForm.querySelectorAll('input, textarea').forEach(input => {
      input.classList.remove('field-error');
    });
  }

  /**
   * AJAX 提交表单
   */
  function submitForm(formData, form) {
    const submitBtn = form.querySelector('.submit-btn');
    const originalBtnText = submitBtn.textContent;
    submitBtn.textContent = '提交中...';
    submitBtn.disabled = true;

    fetch('/api/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          showToast('留言提交成功，感谢您的反馈！', 'success');
          form.reset();
        } else {
          showToast('留言提交失败：' + (data.message || '未知错误'), 'error');
        }
      })
      .catch(error => {
        showToast('网络错误，请稍后重试', 'error');
        console.error('提交表单出错:', error);
      })
      .finally(() => {
        submitBtn.textContent = originalBtnText;
        submitBtn.disabled = false;
      });
  }
}
